import React from "react";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";
import { HeroImage } from "../../../atoms/HeroImage";
import {
  getRecipeCookTime,
  getStoryHeadline,
  getStoryLabel,
  isExternalStory,
  storyTemplates,
} from "../../../utils/story";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import CookTime from "../../../atoms/CookTime";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";

import "./other-story.m.css";

const OtherStory = ({ story, showReadTime, showTimeStamp, showCookTime, sectionSlug }) => {
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);

  const isRecipe = story && story["story-template"] === storyTemplates.recipe;
  const cookTime = getRecipeCookTime(story);

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target} styleName="otherStory">
      <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={{ height: 24, width: 24 }} />
      {label && <Label story={story} />}
      {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
      {cookTime && showCookTime && isRecipe && <CookTime cookTime={cookTime} />}
      {!isRecipe && <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />}
    </Link>
  );
};

OtherStory.prototype = {
  story: PropTypes.shape({
    slug: PropTypes.string,
  }),
  showCookTime: PropTypes.bool,
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default OtherStory;
